export default function initJuryFilter() {
    const yearFilter = document.getElementById('jury-year-filter');
    const orderFilter = document.getElementById('jury-order-filter');
    const letterFilterContainer = document.getElementById('jury-letter-filter');
    const resultsContainer = document.getElementById('jury-results');

    if (!yearFilter || !orderFilter || !letterFilterContainer || !resultsContainer) {
        return;
    }

    const letterButtons = letterFilterContainer.querySelectorAll('.jury__letter-btn');
    let selectedLetter = '';

    function toggleLetterFilter() {
        const orderBy = orderFilter.value;

        if (orderBy === 'letter') {
            letterFilterContainer.classList.add('jury__letter-filter--visible');
        } else {
            letterFilterContainer.classList.remove('jury__letter-filter--visible');
            // Clear selected letter when switching away from letter ordering
            selectedLetter = '';
            letterButtons.forEach(btn => btn.classList.remove('active'));
        }
    }

    function filterJuryMembers() {
        const year = yearFilter.value;
        const orderBy = orderFilter.value;

        // Add loading state
        resultsContainer.classList.add('jury__results--loading');
        resultsContainer.setAttribute('aria-busy', 'true');

        // Make AJAX request
        fetch(juryFilter.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'filter_jury_members',
                nonce: juryFilter.nonce,
                year: year,
                letter: selectedLetter,
                order_by: orderBy
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                resultsContainer.innerHTML = data.data.html;
            } else {
                resultsContainer.innerHTML = '<p class="jury__error">An error occurred. Please try again.</p>';
            }
        })
        .catch(error => {
            console.error('Error filtering jury members:', error);
            resultsContainer.innerHTML = '<p class="jury__error">An error occurred. Please try again.</p>';
        })
        .finally(() => {
            resultsContainer.classList.remove('jury__results--loading');
            resultsContainer.setAttribute('aria-busy', 'false');
        });
    }

    // Add event listeners to dropdowns
    yearFilter.addEventListener('change', filterJuryMembers);

    orderFilter.addEventListener('change', () => {
        toggleLetterFilter();
        filterJuryMembers();
    });

    // Add event listeners to letter buttons
    letterButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const clickedLetter = e.currentTarget.dataset.letter;

            // Toggle selection
            if (selectedLetter === clickedLetter) {
                selectedLetter = '';
                e.currentTarget.classList.remove('active');
            } else {
                selectedLetter = clickedLetter;
                // Remove active class from all buttons
                letterButtons.forEach(btn => btn.classList.remove('active'));
                // Add active class to clicked button
                e.currentTarget.classList.add('active');
            }

            filterJuryMembers();
        });
    });

    // Initialize letter filter visibility
    toggleLetterFilter();
}
